import { FunctionComponent } from 'react';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobSkills: FunctionComponent<Props> = ({
    headline,
    list,
}) => {
    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-skills"
        >
            <LayoutContainer size={Sizes.Small}>
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                <div className="list">
                    {list.map(element => (
                        <div
                            key={element?.id}
                            className="list-element"
                        >
                            <div
                                className="element-content"
                                dangerouslySetInnerHTML={{ __html: element?.name }}
                            />
                        </div>
                    ))}
                </div>
            </LayoutContainer>

        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobSkills;